export default __webpack_public_path__ + "static/media/pexels-ivan-samkov-4989164.1ee1f857.jpg";